import { useContext } from "react";
import { I18nContext } from "../I18nProvider";

export default () => useContext(I18nContext);
